"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _tpmProductIntl = require("@tencent/tpm-product-intl");
var _reportUtil = require("../../utils/reportUtil");
var _componentUtils = require("../../common/componentUtils");
var _HTMLRenderer = _interopRequireDefault(require("../../common/components/HTMLRenderer"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 *
 * @description TpmComparison
 * @author xlongjiang
 * @created 2025-11-14 02:31:50
 */

const TabPanel = _tpmProductIntl.Tab.TabPanel;

/**
 * 格式化组件数据
 * @param properties 组件属性
 * @param options 选项
 * @returns 格式化后的数据
 */
const formatTpmComparisonData = (properties, options = {}) => {
  const _ref = properties || {},
    _ref$porintId = _ref.porintId,
    porintId = _ref$porintId === void 0 ? '' : _ref$porintId,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? '' : _ref$tag,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$desc = _ref.desc,
    desc = _ref$desc === void 0 ? '' : _ref$desc,
    _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? 'default' : _ref$bg,
    _ref$bgColor = _ref.bgColor,
    bgColor = _ref$bgColor === void 0 ? '' : _ref$bgColor,
    _ref$bgImg = _ref.bgImg,
    bgImg = _ref$bgImg === void 0 ? '' : _ref$bgImg,
    _ref$tabList = _ref.tabList,
    tabList = _ref$tabList === void 0 ? [] : _ref$tabList;
  const handleTabList = tabList.map((item, index) => {
    const _item$text = item.text,
      text = _item$text === void 0 ? '' : _item$text,
      _item$columns = item.columns,
      columns = _item$columns === void 0 ? 4 : _item$columns,
      _item$openText = item.openText,
      openText = _item$openText === void 0 ? '' : _item$openText,
      _item$packText = item.packText,
      packText = _item$packText === void 0 ? '' : _item$packText,
      _item$itemList = item.itemList,
      itemList = _item$itemList === void 0 ? [] : _item$itemList,
      _item$fullItemList = item.fullItemList,
      fullItemList = _item$fullItemList === void 0 ? [] : _item$fullItemList;
    const handleItemList = itemList.map((item, key) => {
      const _item$tag = item.tag,
        tag = _item$tag === void 0 ? '' : _item$tag,
        _item$icon = item.icon,
        icon = _item$icon === void 0 ? '' : _item$icon,
        _item$title = item.title,
        title = _item$title === void 0 ? '' : _item$title,
        _item$integerCost = item.integerCost,
        integerCost = _item$integerCost === void 0 ? '' : _item$integerCost,
        _item$decimalCost = item.decimalCost,
        decimalCost = _item$decimalCost === void 0 ? '' : _item$decimalCost,
        _item$originalCost = item.originalCost,
        originalCost = _item$originalCost === void 0 ? '' : _item$originalCost,
        _item$priceUnit = item.priceUnit,
        priceUnit = _item$priceUnit === void 0 ? '' : _item$priceUnit,
        _item$recommendText = item.recommendText,
        recommendText = _item$recommendText === void 0 ? '' : _item$recommendText,
        _item$btnText = item.btnText,
        btnText = _item$btnText === void 0 ? '' : _item$btnText,
        _item$btnHref = item.btnHref,
        btnHref = _item$btnHref === void 0 ? '' : _item$btnHref,
        _item$features = item.features,
        features = _item$features === void 0 ? [] : _item$features,
        _item$configList = item.configList,
        configList = _item$configList === void 0 ? [] : _item$configList;
      const handleBtn = () => {
        const btnExtendProps = {
          'report-event': 'click_Comparison_Item_btn',
          'report-ext1': index,
          'report-ext2': key,
          'report-ext3': btnText || '',
          target: '_blank'
        };
        if (recommendText) {
          return /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
            type: "primary",
            icon: true,
            href: btnHref
          }, btnExtendProps), btnText);
        }
        return /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
          type: "weak",
          icon: true,
          href: btnHref
        }, btnExtendProps), btnText);
      };
      return {
        tag,
        recommendText: recommendText,
        icon: (0, _componentUtils.doComponentsUploadEvent)(icon || '').url,
        title,
        integerCost,
        decimalCost,
        originalCost,
        priceUnit,
        btn: btnText && btnHref ? handleBtn() : null,
        features,
        configList
      };
    });
    const handleFullItemList = fullItemList.map((item, key) => {
      const _item$tag2 = item.tag,
        tag = _item$tag2 === void 0 ? '' : _item$tag2,
        _item$icon2 = item.icon,
        icon = _item$icon2 === void 0 ? '' : _item$icon2,
        _item$title2 = item.title,
        title = _item$title2 === void 0 ? '' : _item$title2,
        _item$integerCost2 = item.integerCost,
        integerCost = _item$integerCost2 === void 0 ? '' : _item$integerCost2,
        _item$decimalCost2 = item.decimalCost,
        decimalCost = _item$decimalCost2 === void 0 ? '' : _item$decimalCost2,
        _item$originalCost2 = item.originalCost,
        originalCost = _item$originalCost2 === void 0 ? '' : _item$originalCost2,
        _item$priceUnit2 = item.priceUnit,
        priceUnit = _item$priceUnit2 === void 0 ? '' : _item$priceUnit2,
        _item$btnText2 = item.btnText,
        btnText = _item$btnText2 === void 0 ? '' : _item$btnText2,
        _item$btnHref2 = item.btnHref,
        btnHref = _item$btnHref2 === void 0 ? '' : _item$btnHref2,
        _item$features2 = item.features,
        features = _item$features2 === void 0 ? [] : _item$features2,
        _item$configList2 = item.configList,
        configList = _item$configList2 === void 0 ? [] : _item$configList2;
      const handleBtn = () => {
        const btnExtendProps = {
          'report-event': 'click_Comparison_Item_Full_btn',
          'report-ext1': index,
          'report-ext2': key,
          'report-ext3': btnText || '',
          target: '_blank'
        };
        return /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
          type: "primary",
          icon: true,
          href: btnHref
        }, btnExtendProps), btnText);
      };
      return {
        tag,
        icon: (0, _componentUtils.doComponentsUploadEvent)(icon || '').url,
        title,
        integerCost,
        decimalCost,
        originalCost,
        priceUnit,
        btn: btnText && btnHref ? handleBtn() : null,
        features,
        configList
      };
    });
    return {
      text,
      columns,
      openText,
      packText,
      data: handleItemList,
      fullData: handleFullItemList
    };
  });
  return {
    porintId,
    tag,
    title: title ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: title
    }) : '',
    desc: desc ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: desc
    }) : '',
    bg,
    bgColor,
    bgImg: (0, _componentUtils.doComponentsUploadEvent)(bgImg || '').url,
    tabList: handleTabList
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} "数据"表单内容
  style,
  // {object} "样式"表单内容
  commonStyle,
  // {object} "组件自定义样式"表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatTpmComparisonD = formatTpmComparisonData(data, {
        domains
      }),
      porintId = _formatTpmComparisonD.porintId,
      tag = _formatTpmComparisonD.tag,
      title = _formatTpmComparisonD.title,
      desc = _formatTpmComparisonD.desc,
      bg = _formatTpmComparisonD.bg,
      bgColor = _formatTpmComparisonD.bgColor,
      bgImg = _formatTpmComparisonD.bgImg,
      tabList = _formatTpmComparisonD.tabList;
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId,
      className: `gems-materials-qci____newUI-TpmComparison`
    }, (0, _reportUtil.reportShow)(['show_newUI_TpmComparison', componentKey, title || ''])), /*#__PURE__*/React.createElement(_tpmProductIntl.Section, {
      tag: tag,
      title: title,
      desc: desc,
      bg: bg,
      bgColor: bgColor,
      bgImg: bgImg
    }, tabList.length > 1 ? /*#__PURE__*/React.createElement(_tpmProductIntl.Tab, {
      itemList: tabList.map((item, index) => ({
        text: item.text,
        id: `id${index}`
      }))
    }, tabList.map((item, index) => /*#__PURE__*/React.createElement(TabPanel, {
      id: `id${index}`
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.Comparison, item)))) : tabList.map((item, index) => /*#__PURE__*/React.createElement(_tpmProductIntl.Comparison, Object.assign({}, item, {
      key: index
    })))));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}